export default "__VITE_ASSET__OK2M_dj4__"